export const TEMPLATE_STATUS = {
    DRAFT: 'draft',
    ACTIVE: 'active',
    DEACTIVATED: 'deactivated',
} as const

export type TemplateStatus = (typeof TEMPLATE_STATUS)[keyof typeof TEMPLATE_STATUS]

export const TEMPLATE_STATUS_LABELS: Record<TemplateStatus, string> = {
    [TEMPLATE_STATUS.DRAFT]: 'Borrador',
    [TEMPLATE_STATUS.ACTIVE]: 'Activo',
    [TEMPLATE_STATUS.DEACTIVATED]: 'Desactivado',
}

export function normalizeTemplateStatus(raw?: string | null): TemplateStatus | undefined {
    if (raw === undefined || raw === null || raw === '') return undefined

    const value = String(raw).trim().toLowerCase()
    const known = Object.values(TEMPLATE_STATUS) as string[]

    return known.includes(value) ? (value as TemplateStatus) : undefined
}

export function isDraft(status?: TemplateStatus): boolean {
    return status === TEMPLATE_STATUS.DRAFT
}

export function isDeactivated(status?: TemplateStatus): boolean {
    return status === TEMPLATE_STATUS.DEACTIVATED
}
